import { FlexBox, Spinner } from '@dixa/lib-shared-habla';

export default function PageSkeleton(): JSX.Element {
  return (
    <FlexBox justifyContent="center" alignItems="center" height="100%">
      <Spinner />
    </FlexBox>
  );
}
